/*=========================================================================================
  File Name: moduleSpaceState.js
  Description: Space Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  allExamList:[],
  currentExamList:[],
  writingExamList:[],
  scheduleExamList:[],
  defectExamList:[],
  adminExamList: [],
  schoolInfo:{},
  testExamList: [],
  userExamList: [],
  subjectList:[],
  questionList:[],
  multipleQuestionList:[],
  activeExam:'',
  activeSubject:'',
  activeSubjectId : '',
  activeQuestion:'',
  subjectType:[],
  subjectDetailType:[],
  subjectCode: [],
  practiceExamList: [],
  categoryList: [],
  mainCategoryList: [],
  subCategoryList: [],
  progressExam: '',
  popUpState: false,
  nextExamList: [],
  plannedExamList: [],
  keyWord:null,
  collegeInfo: [
    { id : 1,
      name: '서울대학교' ,
      service_state: 0,
      service_end_time: '',
      grade_system: 0,
      img_name: 'snu.png',
      slogan: '누군가 조국의 미래를 묻거든 고개를 들어 관악을 보게 하라',
      address: '',
      school_info: '',
      local_type_id: '1' ,
    },
    { id : 2, name: '연세대학교' , local_type_id: '1'},
    { id : 3, name: '고려대학교' , local_type_id: '1'},
    { id : 4, name: '중앙대학교' , local_type_id: '1'},
    { id : 5, name: '성균관대학교' , local_type_id: '1'},
    { id : 6, name: '서울예술대학교' , local_type_id: '1'},
    { id : 7, name: '서울과학기술대학교' , local_type_id: '1'},
    { id : 8, name: '서울교육대학교' , local_type_id: '1'},
    { id : 9, name: '강원대학교' , local_type_id: '4'},
    { id : 10, name: '카이스트' , local_type_id: '2'},
    { id : 11, name: '광주대학교' , local_type_id: '2'},
    { id : 12, name: '부산대학교' , local_type_id: '2'},
    { id : 13, name: '인하공업전문대학' , local_type_id: '2'},
    { id : 14, name: '대구대학교' , local_type_id: '2'},
    { id : 15, name: '충북대학교' , local_type_id: '5'},
    { id : 16, name: '경남대학교' , local_type_id: '6'},
    { id : 17, name: '계원예술대학교' , local_type_id: '3'},
  ],
  // majorList : [
  //   {
  //     name: '경영학과',
  //     school_id: 1,
  //     major_type_id: 1,
  //     state: 1,
  //     standard: 0,
  //     tag: ['운영' , 'ceo' , '회사운영'],
  //     major_info: [
  //       { grouping: 0,
  //         date_id: 1,
  //         wanted: 50,
  //         competition_rate: '5.72:1',
  //       },{
  //         grouping: 0,
  //         date_id: 2,
  //         wanted: 45,
  //         competition_rate: '5.56:1',
  //       }
  //     ],
  //   },{
  //     grouping: '2',
  //     name: '수학과',
  //     school_id: 1,
  //     major_type_id: 2,
  //     state: 1,
  //     standard: 0,
  //     tag: ['수학자' , '알고리즘'],
  //     major_info: [
  //       {
  //         grouping: 1,
  //         date_id: 1,
  //         wanted: 50,
  //         competition_rate: '4.33:1',
  //       },{
  //         grouping: 1,
  //         date_id: 2,
  //         wanted: 45,
  //         competition_rate: '4.21:1',
  //       }
  //     ],
  //   }
  // ],
  admissionList: [
      {
        subject: '영어',
        score: 100,
        rank: 1,
        major_id: 1,
        subject_id: 4,
        school_id: 1,
        subject_type_id: 2,
        subject_date_id: 1
      },{
        subject: '국어',
        score: 40,
        rank: 1,
        major_id: 1,
        subject_id: 1,
        school_id: 1,
        subject_type_id: 1,
        subject_date_id: 1
      },{
        subject: '영어',
        score: 100,
        rank: 1,
        major_id: 2,
        subject_id: 4,
        school_id: 1,
        subject_type_id: 2,
        subject_date_id: 1
      },{
        subject: '수학Ⅱ',
        score: 100,
        rank: 1,
        major_id: 2,
        subject_id: 3,
        school_id: 1,
        subject_type_id: 3,
        subject_date_id: 1
      },{
        subject: '한국사',
        score: 70,
        rank: 1,
        major_id: 2,
        subject_id: 5,
        school_id: 1,
        subject_type_id: 4,
        subject_date_id: 1
      },{
        subject: '탐구1',
        score: 45,
        rank: 1,
        subject_id: 6,
        major_id: 1,
        school_id: 1,
        subject_type_id: 5,
        subject_date_id: 1,
      },
      {
        subject: '탐구2',
        score: 50,
        rank: 1,
        subject_id: 7,
        major_id: 1,
        school_id: 1,
        subject_type_id: 5,
        subject_date_id: 1
      },{
        subject: '탐구1',
        score: 48,
        rank: 1,
        subject_id: 6,
        major_id: 2,
        school_id: 1,
        subject_type_id: 5,
        subject_date_id: 1,
      },
      {
        subject: '탐구2',
        score: 50,
        rank: 1,
        subject_id: 7,
        major_id: 2,
        school_id: 1,
        subject_type_id: 5,
        subject_date_id: 1
      }
  ],
  activeCollege : {},
  activeMajor: {},
  scoreList: {},
  examId: '',
  examList:{},
  weekList: [],
  univInfo: [],
  univList: [],
  majorList: [],
  majorItem: [],
  grdList: [],
  grdDetail: {},
  univImg: null
}
